import { createContext, useContext } from 'react'

export interface RecordSheetContextValue {
  openRecord: (key: string, id: string | number) => void
}

export const RecordSheetContext = createContext<RecordSheetContextValue | null>(
  null
)

export function useRecordSheet(): RecordSheetContextValue {
  const ctx = useContext(RecordSheetContext)
  if (!ctx) throw new Error('useRecordSheet must be used inside RecordSheetProvider')
  return ctx
}
